import { isEmpty } from "@s-libs/micro-dash";

import { API_BASE_URL } from "@/api/api.config";
import useRestQuery from "@/remoteState/useRestQuery";

const buildParamsString = (params) => {
  return isEmpty(params) ? "" : `?${new URLSearchParams(params).toString()}`;
};

const useUserSchoolGet = (id, params = null, skip = false) => {
  const paramStrings = buildParamsString(params);
  return useRestQuery(
    `${API_BASE_URL}/api/v2/user/${id}/school/${paramStrings}`,
    { skip: !id || skip },
  );
};

export default useUserSchoolGet;
